import { Typography } from '@mui/material';
import React, { CSSProperties } from 'react';
import AppCustomIcon from '../../../app/features/icon/AppIcon';
import IFaqArticle from '../interfaces/IFaqArticle';
import faqContact1 from '../assets/faq_contact_1.png';
import faqContact2 from '../assets/faq_contact_2.png';
import faqDoubleAuth from '../assets/faq_double_auth.png';
import faqInfoCard from '../assets/faq_info_card.png';

const imgStyle: CSSProperties = {
	maxWidth: '-webkit-fill-available',
};
const useFaqArticlesInvestor = () => {
	const faqArticles: IFaqArticle[] = [
		{
			title: {
				en: 'How can I request access to Sienna Investment Managers portal for one of my colleague?',
				fr: "Comment puis-je demander l'accès au portail de Sienna Investment Managers pour un de mes collègues ?",
			},
			content: {
				en: (
					<>
						Please send a request to our support team:{' '}
						<a href="mailto:help@sienna-im.com" target="_blank" rel="noreferrer">
							help@sienna-im.com
						</a>{' '}
					</>
				),
				fr: (
					<>
						Veuillez envoyer une demande à notre équipe de support :{' '}
						<a href="mailto:help@sienna-im.com" target="_blank" rel="noreferrer">
							help@sienna-im.com
						</a>{' '}
					</>
				),
			},
		},
		{
			title: {
				en: 'How can I set up my double authentication method?',
				fr: 'Comment puis-je configurer ma méthode de double authentification ?',
			},
			content: {
				en: (
					<>
						<Typography component="p" gutterBottom>
							1. Click on account icon in the upper right of the portal{' '}
							<AppCustomIcon tag="user_account" />, to go your account page.
						</Typography>
						<Typography component="p" gutterBottom>
							2. Set up from 1 to 3 of the proposed authentication method (SMS, code sent by email, secret
							question)
						</Typography>
					</>
				),
				fr: (
					<>
						<Typography component="p" gutterBottom>
							1. Cliquez sur l&apos;icône du compte en haut à droite du portail{' '}
							<AppCustomIcon tag="user_account" />, pour accéder à la page de votre compte.
						</Typography>
						<Typography component="p" gutterBottom>
							2. Configurez de 1 à 3 méthodes d&apos;authentification proposées (SMS, code envoyé par
							email, question secrète).
						</Typography>
					</>
				),
			},
		},
		{
			title: {
				en: 'How do I change my double authentication process?',
				fr: 'Comment puis-je modifier mon processus de double authentification ?',
			},
			content: {
				en: (
					<>
						<Typography component="p" gutterBottom>
							1. Click on account icon in the upper right of the portal{' '}
							<AppCustomIcon tag="user_account" /> to go your account page,
						</Typography>
						<Typography component="p" gutterBottom>
							2. Click on the &ldquo;Change security methods&rdquo; button,
						</Typography>
						<Typography component="p" gutterBottom>
							3. Click on &ldquo;remove&rdquo; button to disable an authentication process,
						</Typography>
						<Typography component="p" gutterBottom>
							4. If you have set up all authentication methods, the most used one becomes the default
							method.
						</Typography>
						<img src={faqDoubleAuth} style={imgStyle} />
					</>
				),
				fr: (
					<>
						<Typography component="p" gutterBottom>
							1. Cliquez sur l&apos;icône du compte en haut à droite du portail pour accéder à la page de
							votre compte <AppCustomIcon tag="user_account" />,
						</Typography>
						<Typography component="p" gutterBottom>
							2. Cliquez sur le bouton &ldquo;Double authentification - Modifier&rdquo;,
						</Typography>
						<Typography component="p" gutterBottom>
							3. Cliquez sur le bouton &ldquo;supprimer&rdquo; pour désactiver un processus
							d&apos;authentification,
						</Typography>
						<Typography component="p" gutterBottom>
							4. Si vous avez configuré toutes les méthodes d&apos;authentification, la plus utilisée
							devient la méthode par défaut.
						</Typography>
						<img src={faqDoubleAuth} style={imgStyle} />
					</>
				),
			},
		},
		{
			title: {
				en: 'How do I change my account profile information?',
				fr: 'Comment modifier les informations du profil de mon compte ?',
			},
			content: {
				en: (
					<>
						<Typography component="p" gutterBottom>
							In the profile page (accessible via the account icon in the upper right of the portal{' '}
							<AppCustomIcon tag="user_account" />
							), you can edit your personal information, your settings, password and security methods.
						</Typography>
						<Typography component="p" gutterBottom>
							You can not modify by yourself your e-mail and organization. In case you need to change your
							email, please send a request to our support team:{' '}
							<a href="mailto:help@sienna-im.com" target="_blank" rel="noreferrer">
								help@sienna-im.com
							</a>
						</Typography>
					</>
				),
				fr: (
					<>
						<Typography component="p" gutterBottom>
							Dans la page de profil (accessible via l&apos;icône de compte en haut à droite du portail{' '}
							<AppCustomIcon tag="user_account" />
							), vous pouvez modifier vos informations personnelles, vos paramètres, votre mot de passe et
							vos méthodes de sécurité.
						</Typography>
						<Typography component="p" gutterBottom>
							Vous ne pouvez pas modifier vous-même votre e-mail et votre organisation. Si vous avez
							besoin de modifier votre e-mail, veuillez envoyer une demande à notre équipe de support :{' '}
							<a href="mailto:help@sienna-im.com" target="_blank" rel="noreferrer">
								help@sienna-im.com
							</a>
						</Typography>
					</>
				),
			},
		},
		{
			title: {
				en: 'How can I ask information about some elements displayed in the portal?',
				fr: 'Comment puis-je demander des informations sur certains éléments affichés sur le portail ?',
			},
			content: {
				en: (
					<>
						Please contact your client service or commercial contact.
						<div style={{ width: '-webkit-fill-available' }}>
							<img src={faqContact1} style={imgStyle} />
							<img src={faqContact2} style={imgStyle} />
						</div>
					</>
				),
				fr: (
					<>
						Veuillez contacter votre service client ou votre contact commercial.
						<div>
							<img src={faqContact1} style={imgStyle} />
							<img src={faqContact2} style={imgStyle} />
						</div>
					</>
				),
			},
		},
		{
			title: {
				en: 'What is the difference between estimated and audited data?',
				fr: 'Quelle est la différence entre les données estimées et les données auditées ?',
			},
			content: {
				en: (
					<>
						<Typography component="p" gutterBottom>
							Estimated data are provided on the basis of the latest known positions per expertise (the
							estimation date is specified within each expertise on its synthesis board as well as on the
							fund detail pages). They include most recent data on commitments &amp; capital calls and an
							estimated Net Asset Value. The estimation is made by Sienna team and should not be
							considered as engaging.
						</Typography>
						<Typography component="p" gutterBottom>
							Audited data includes a Net Asset Value for each fund that has been audited by its fund
							accountants.
						</Typography>
					</>
				),
				fr: (
					<>
						<Typography component="p" gutterBottom>
							Les données estimées sont fournies sur la base des dernières positions connues par expertise
							(la date d&apos;estimation est précisée au sein de chaque expertise sur le tableau de
							synthèse de celle-ci ainsi que sur les pages de détail des fonds). Elles comprennent les
							données les plus récentes sur les engagements et les appels de fonds ainsi qu&apos;une
							valeur liquidative (VL) estimée. Les estimations sont réalisées par les équipes de Sienna et
							ne doivent pas être considérées comme engageantes.
						</Typography>
						<Typography component="p" gutterBottom>
							Les données auditées comprennent une valeur liquidative (VL) pour chaque fonds qui a été
							auditée par le commissaire aux comptes du fond.
						</Typography>
					</>
				),
			},
		},
		{
			title: {
				en: 'What means “n.s.”, “n.c.” or “n/a” ?',
				fr: 'Que signifie "n.s.", "n.c." ou "n/a" ?',
			},
			content: {
				en: (
					<>
						<Typography component="p" gutterBottom>
							<b>“n.s.” means that the KPI is not significant</b>. This mainly happens when your first
							capital call in a fund (or group of funds) is not at least 18 months old. Please note that
							the data of a fund with an IRR in “n.s.” are including in the calculation of your total
							portfolio IRR.
						</Typography>
						<Typography component="p" gutterBottom>
							<b>“n.c.” means the KPI</b> (or elements required to calculate this KPI){' '}
							<b>are not communicated by Sienna</b>. This may happen because Sienna is not required to
							communicate this element (for instance the SFDR of certain type of funds) or because Sienna
							has not yet communicated this data (for instance, the last audited NAV of a fund).
						</Typography>
						<Typography component="p" gutterBottom>
							<b>“n/a” means the data or KPI</b> is not applicable. For instance, the IRR of a fund, where
							you have committed funds and none were called yet.
						</Typography>
					</>
				),
				fr: (
					<>
						<Typography component="p" gutterBottom>
							<b>&quot;n.s.&quot; signifie que le KPI n&apos;est pas significatif</b>. Cela se produit
							principalement lorsque le premier appel de capitaux d&apos;un fonds (ou groupe de fonds) a
							moins de 18 mois. Veuillez noter que les données d&apos;un fonds avec un TRI
							&quot;n.s.&quot; sont incluses dans le calcul du TRI total de votre portefeuille.
						</Typography>
						<Typography component="p" gutterBottom>
							<b>&quot;n.c.&quot; signifie que le KPI</b> (ou les éléments nécessaires au calcul de ce
							KPI) <b>n&apos;est pas communiqué par Sienna</b>. Cela peut se produire parce que Sienna
							n&apos;est pas tenue de communiquer cet élément (par exemple le SFDR de certains types de
							fonds) ou parce que Sienna n&apos;a pas encore communiqué cette donnée (par exemple, la
							dernière VL auditée d&apos;un fonds).
						</Typography>
						<Typography component="p" gutterBottom>
							<b>&quot;n/a&quot; signifie que la donnée ou le KPI n&apos;est pas applicable</b>. Par
							exemple, le TRI d&apos;un fonds lorsque vous avez engagé des fonds et qu&apos;aucun n&apos;a
							encore été appelé.
						</Typography>
					</>
				),
			},
		},
		{
			title: {
				en: 'Where can I find the management company of a fund ?',
				fr: "Où puis-je trouver la société de gestion d'un fonds ?",
			},
			content: {
				en: (
					<>
						<Typography component="p" gutterBottom>
							In “My investments” pages, you can click on the name of a fund to access a page with its
							detailed information. At the bottom of this page, the management company is mentioned in the
							“Roles” section.
						</Typography>
						<img src={faqInfoCard} style={imgStyle} />
					</>
				),
				fr: (
					<>
						<Typography component="p" gutterBottom>
							Dans la page “Mes investissements”, vous pouvez cliquer sur le nom d’un fonds pour accéder à
							ses informations détaillées . Au bas de cette nouvelle page, la société de gestion d’un fond
							est précisée dans la section “Rôles”
						</Typography>
						<img src={faqInfoCard} style={imgStyle} />
					</>
				),
			},
		},
	];

	return faqArticles;
};

export default useFaqArticlesInvestor;
